import { render, staticRenderFns } from "./showMode.vue?vue&type=template&id=1303515c&"
import script from "./showMode.vue?vue&type=script&lang=js&"
export * from "./showMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports